// extracted by mini-css-extract-plugin
export var calculatedBadge = "_wj-8";
export var container = "_wj-0";
export var radioDot = "_wj-5";
export var radioDotSelected = "_wj-6";
export var row = "_wj-1";
export var rowFirst = "_wj-2";
export var rowLast = "_wj-3";
export var rowSelected = "_wj-4";
export var strikethrough = "_wj-7";